export default __webpack_public_path__ + "static/media/395.dae38951.png";